import { IBookingResponse } from '@smiles/core-traveler-universe/dist/Types/Hotels/Bookings.types';

const types = {
  SET_USER_RESERVATIONS_LIST: 'userReservationsList/SET_USER_RESERVATIONS_LIST',
};

type IMyHotelsReduxState = IBookingResponse[] | null;

const initialState: IMyHotelsReduxState = null;

export default function reducer(state = initialState, action: any = {}): IMyHotelsReduxState {
  if (action.type === types.SET_USER_RESERVATIONS_LIST) {
    return action.payload;
  }
  return state;
}

const setUserReservationsList = (reservationsList: IBookingResponse[]) => ({
  type: types.SET_USER_RESERVATIONS_LIST,
  payload: reservationsList,
});

export const userReservationsListActions = {
  setUserReservationsList,
};
